<template>
    <BCard no-body>
      <BCardHeader class="pb-50">
        <h5> {{$t("Filters")}} </h5>
      </BCardHeader>
      <BCardBody>
        <BRow>
          <BCol cols="12" md="3" class="mb-md-0 mb-2" >
            <label>{{$t('Section')}}</label>
            <vSelect v-model="sectionFilter" :options="sections" label="name" class="w-100" :reduce="val => val.id" v-if="sections"/>
          </BCol>
          <BCol cols="12" md="3" class="mb-md-0 mb-2" >
            <label>{{$t('Tax')}}</label>
            <vSelect v-model="taxFilter" :options="taxes" label="name" class="w-100" :reduce="val => val.id"  v-if="taxes"/>
          </BCol>
          <BCol v-if="groups && groups.length>1" cols="12" md="3" class="mb-md-0 mb-2" >
            <label>{{$t('Group')}}</label>
            <vSelect v-model="groupFilter" :options="groups" label="name" class="w-100" :reduce="val => val.id" />
          </BCol>
          <BCol cols="12" md="3" class="mb-md-0 mb-2">
            <label>Estado</label>
            <vSelect v-model="statusFilter" :options="status" label="label" class="w-100" :reduce="status => status.value" v-if="status" />
          </BCol>
        </BRow>
      </BCardBody>
    </BCard>
  </template>

  <script>
  import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
  import { inject } from '@vue/composition-api';
  import vSelect from 'vue-select'

  export default {
    components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
    setup(){
        const sectionFilter = inject('sectionFilter')
        const statusFilter = inject('statusFilter')
        const groupFilter = inject('groupFilter')
        const taxFilter = inject('taxFilter')
        const sections = inject('sections')
        const groups = inject('groups')
        const taxes = inject('taxes')
        const status = [
            { label: 'Activo', value: true },
            { label: 'Inactivo', value: false },
        ]

        return {
            sectionFilter,
            statusFilter,
            groupFilter,
            taxFilter,
            sections,
            groups,
            status,
            taxes,
        }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
